// Écran Banque (journal de trésorerie bancaire — compte 512000).
import React from "react";
import { Landmark } from "lucide-react";
import SaisieTresorerie from "@/components/SaisieTresorerie";

export default function Banque() {
  return (
    <SaisieTresorerie
      config={{
        journal: "banque",
        titre: "Banque",
        sousTitre: "Enregistrez les mouvements de votre compte bancaire.",
        icone: Landmark,
        moyensPaiement: ["Virement", "Chèque", "Carte bancaire", "Prélèvement"],
        pageTestId: "page-banque",
        journalCode: "BQ",
        libelleJournal: "BQ — Banque",
        compteTresorerie: "512000",
      }}
    />
  );
}
